/**
 * KnowledgeRenderer — pluggable renderer for one MediaKind.
 *
 * Key design (Tschepp's catch in the design review): mount() returns
 * a RendererHandle whose .update() takes partial RenderOptions. Skin
 * state-changes (active-annotation, hover, theme-tweaks at runtime)
 * route through update() — NOT remount. Three.js scenes survive
 * across state-changes; React effects of consuming components call
 * handle.update(...) instead of unmount+mount.
 *
 * STATUS: Skeleton — interfaces + registry class shell. No default
 * renderers implemented yet. Locked by review with Tschepp before
 * IllustrationRenderer / VideoRenderer / GLBRenderer impl.
 */
/** Registry of renderers — Skin can register custom variants before
 *  KnowledgeView mounts, falling back to library defaults otherwise.
 *  First-match wins; registration order is precedence (Skin overrides
 *  library defaults by registering BEFORE the defaults). */
export class KnowledgeRendererRegistry {
    constructor() {
        this.renderers = [];
    }
    register(renderer) {
        this.renderers.push(renderer);
    }
    /** Find the first renderer whose canRender() accepts the item, or
     *  null if none registered for that kind. */
    resolve(item) {
        return this.renderers.find((r) => r.canRender(item)) ?? null;
    }
    /** Number of renderers — for debug / skin diagnostics. */
    get size() {
        return this.renderers.length;
    }
}
//# sourceMappingURL=renderer.js.map